import React, { useEffect, useState } from "react";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import alertify from "alertifyjs";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { AddMaster } from "../../services/apiUtils";

/**
 * MasterRegister is a React component for registering a new master.
 * It fetches the current user id from local storage and sets it to the component state.
 * It renders a form with input fields for master name, city, village, and location.
 * The form is validated on submission and on blur for each field.
 * If the form is valid, it sends a request to the server to add the new master.
 * If the request is successful, it redirects to the master list page.
 * If the request fails, it displays an error message.
 */

const MasterRegister = () => {
  const [formData, setFormData] = useState({
    MasterID: "",
    MasterName: "",
    Village: "",
    City: "",
    location: "",
  });
  const [UserId, setUserId] = useState();

  useEffect(() => {
    const UserName = localStorage.getItem("user_id");
    if (UserName) {
      setUserId(UserName);
    }
  }, []);

  const [errors, setErrors] = useState({});
  const history = useHistory();

  const validateField = (name, value) => {
    const formattedName = name
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .replace(/^./, (str) => str.toUpperCase());
    return value.trim() ? "" : `${formattedName} is required`;
  };

  const formHandler = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: validateField(name, value) });
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setErrors({ ...errors, [name]: validateField(name, value) });
  };

  /**
   * Handles the form submission and validates the input data. If all inputs are
   * valid, it calls the `AddMaster` API to add a new master and if successful,
   * resets the form data and errors, and redirects to the `/master` route.
   * If any of the inputs are invalid, it sets the corresponding error messages in
   * the component state.
   * @param {React.FormEvent<HTMLFormElement>} e - The form event object.
   */
  const submitHandler = async (e) => {
    e.preventDefault();
    let formErrors = {};
    Object.keys(formData).forEach((key) => {
      formErrors[key] = validateField(key, formData[key]);
    });
    setErrors(formErrors);

    if (Object.values(formErrors).every((err) => err === "")) {
      try {
        const FullData = {
          Created_by: UserId,
          MasterId: formData.MasterID.trim(),
          City: formData.City.trim(),
          Village: formData.Village.trim(),
          Location: formData.location.replace(/[^\d.,-]/g, ""),
          Name: formData.MasterName.trim(),
          Type: 2,
          FormerID: 1,
          Status: 1,
        };
        console.log("formData: ", FullData);
        const response = await AddMaster(FullData);
        console.log("response: ", response);
        alertify.success("Master Registration Successful!");
        history.push("/master");
      } catch (error) {
        console.log("error: ", error);
        alertify.error("Error: ", error);
      }
      setFormData({
        MasterName: "",
        country: "",
        location: "",
      });
      setErrors({});
    } else {
      alertify.error("Please fix the errors in the form");
    }
  };

  return (
    <div className="page-wrapper">
      <Header />
      <Sidebar />
      <div className="col-xl-6 d-flex user_edit">
        <div className="card flex-fill">
          <div className="card-header d-flex align-items-center justify-content-between">
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => history.push("/master")}
            >
              ← Back
            </button>

            <h5 className="card-title text-uppercase m-0 flex-grow-1 text-center">
              Master Registration
            </h5>

            {/* spacer to balance layout */}
            <div style={{ width: 60 }}></div>
          </div>

          <div className="card-body">
            <form onSubmit={submitHandler}>
              {Object.keys(formData).map((field) => (
                <div className="input-block mb-3 row" key={field}>
                  <label className="col-lg-3 col-form-label">
                    {field
                      .replace(/([a-z])([A-Z])/g, "$1 $2")
                      .replace(/^./, (str) => str.toUpperCase())}
                  </label>
                  <div className="col-lg-9">
                    <input
                      type="text"
                      name={field}
                      className="form-control"
                      value={formData[field]}
                      onChange={formHandler}
                      onBlur={handleBlur}
                      required
                    />
                    {errors[field] && (
                      <small className="text-danger">{errors[field]}</small>
                    )}
                  </div>
                </div>
              ))}
              <div className="text-end">
                <button type="submit" className="btn btn-primary">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MasterRegister;
